module.exports = __webpack_public_path__ + "static/media/trustimg.dd73cf7f.png";